<template>
  <CSidebar    
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])" >
    <CSidebarBrand class="d-md-down-none" to="/">
      <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        src="img/avatars/logo2.png"
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        src="img/avatars/logo2.png"
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>
    <CIcon :icon="cilUser" size="lg" class="text-primary" />
    <CRenderFunction style="size: 50px;" class="simplebar-mask" flat :content-to-render="$options.nav" />

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])" />
  </CSidebar>
</template>

<script>
import nav from './_nav'
import * as icons from '@coreui/icons';

export default {
  name: 'TheSidebar',
  inject: ['icons'],
  nav,
  created() {
    this.permission()
  },
  methods: {    
    permission() {
        this.$options.nav = admin;
        // this.$options.nav=nav;
        // console.log(JSON.stringify(nav));
    }
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}

const admin = [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: '主控版',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          text: 'NEW'
        }
      },     
      {
          _name: 'CSidebarNavTitle',
          _children: ['營運作業']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: '營運單位模組',
        route: '',
        icon: { content: icons.cilBalanceScale },
        items: [
          {
            name: '部門資料設定',
            to: '/Operations/Department',
            icon: { content: icons.cilBank }
          },  
          {
            name: '人員資料設定',
            to: '/Operations/Users',
            icon: { content: icons.cilMoodGood }
          },  
          {
            name: '企業用戶類別',
            to: '/Operations/EnterpriseType',
            icon: { content: icons.cilMoney }
          }, 
          {
            name: '企業用戶資料',
            to: '/Operations/EnterpriseData',
            icon: { content: icons.cilNotes }
          }, 
        ]
      },
      {
          _name: 'CSidebarNavTitle',
          _children: ['標籤作業']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: '標籤設定模組',
        route: '',
        icon: { content: icons.cilNoteAdd },
        items: [
          {
            name: '倉庫資料設定',
            to: '/Label/StorehouseDataSet',
            icon: { content: icons.cilAmericanFootball }
          },  
          {
            name: '生產單位設定',        
            to: '/Label/ProductionUnitSet',
            icon: { content: icons.cilApple }
          },  
          {
            name: '標籤款式資料設定',
            to: '/Label/ShapeDataSet',
            icon: { content: icons.cilAlbum }
          },  
          {
            name: '標籤狀態清單設定',
            to: '/Label/StatusListSet',
            icon: { content: icons.cilAudioSpectrum }
          },           
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: '標籤作業模組',
        route: '',
        icon: { content: icons.cilNoteAdd },
        items: [         
          {
            name: '標籤訂購單',
            to: '/Label/Order',
            icon: { content: icons.cilBasket }
          },  
          {
            name: '標籤生產單',
            to: '/Label/Production',
            icon: { content: icons.cilBath }
          },  
          {
            name: '標籤入庫單',
            to: '/Label/StockIn',
            icon: { content: icons.cilBoatAlt }
          }, 
          {
            name: '生產作廢單',
            to: '/Label/ProductionInvalid',
            icon: { content: icons.cilTrash }
          }, 
          {
            name: '標籤出貨單',
            to: '/Label/Ship',
            icon: { content: icons.cilTriangle }
          },          
          {
            name: '標籤狀態查詢',
            to: '/Label/Search',
            icon: { content: icons.cilAmericanFootball }
          },
          /*{
            name: '標籤退貨入庫單',
            to: '/Label/ReturnStockIn',
            icon: { content: icons.cilToggleOn }
          },
          {
            name: '倉庫調撥單',
            to: '/Label/TransferOrder',
            icon: { content: icons.cilViewColumn }
          },
          {
            name: '標籤序號異動作業',
            to: '/Label/SerialChange',
            icon: { content: icons.cilWalk }
          },
          {
            name: '標籤批次異動作業',
            to: '/Label/BatchChange',
            icon: { content: icons.cilWrapText }
          },
          {
            name: '標籤狀態查詢',
            to: '/Label/Status',
            icon: { content: icons.cilWatch }
          },*/
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: '全鏈路作業模組',
        route: '',
        icon: { content: icons.cilNoteAdd },
        items: [
          {
            name: '登載作業',
            to: '/Full/Publish',
            icon: { content: icons.cilAmericanFootball }
          },  
          {
            name: '退貨作業',        
            to: '/Full/Purchase',
            icon: { content: icons.cilApple }
          },  
          {
            name: '標籤狀態變更',
            to: '/Full/Status',
            icon: { content: icons.cilAlbum }
          },   
          {
            name: '全鏈路接收紀錄',
            to: '/Full/FullLinkReceiver',
            icon: { content: icons.cilLocomotive },
          },            
          {
            name: '全鏈路傳送紀錄',
            to: '/Full/FullLinkSend',
            icon: { content: icons.cilLan },
          },        
        ]
      },
      {
          _name: 'CSidebarNavTitle',
          _children: ['App作業']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'App管理模組',
        route: '',
        icon: { content: icons.cilToilet },
        items: [
          {
            name: 'App訊息管理',
            to: '/App/Message',
            icon: { content: icons.cilStorage },
          },  
          {
            name: 'App版本管理',
            to: '/App/Version',
            icon: { content: icons.cilAlbum },
          },  
          {
            name: 'App相機管理',
            to: '/App/CameraSetting',
            icon: { content: icons.cilOpacity },
          },           
        ]
      },
       {
        _name: 'CSidebarNavDropdown',
        name: 'App查詢模組',
        route: '',
        icon: { content: icons.cilToilet },
        items: [       
          {
            name: '使用者編號查詢',
            to: '/App/UserSearch',
            icon: { content: icons.cilMeh },
          }, 
          {
            name: '手機掃描紀錄',
            to: '/App/PhoneScanner',
            icon: { content: icons.cilList },
          }, 
          {
            name: '網頁查詢紀錄',
            to: '/App/WebScanner',
            icon: { content: icons.cilListNumberedRtl },
          },
          {
            name: '公眾號查詢紀錄',
            to: '/App/WeixinScanner',
            icon: { content: icons.cilListNumbered },
          },
          {
            name: '官網掃描紀錄',
            to: '/App/OfficialScanner',
            icon: { content: icons.cilList },
          },
        ]
      },
      {
          _name: 'CSidebarNavTitle',
          _children: ['系統作業']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: '操作紀錄查詢',
        route: '',
        icon: { content: icons.cilLoop },
        items: [
          /*{
            name: '營運單位操作者記錄',
            to: '/OperateLog/Customer',
            icon: { content: icons.cilLocomotive },
          },*/  
          {
            name: '系統錯誤記錄',
            to: '/OperateLog/System',
            icon: { content: icons.cilLocomotive },
          }  
        ]
      },     
    /*
      {
        _name: 'CSidebarNavDropdown',
        name: '系統參數及公司設定',
        route: '',
        icon: { content: icons.cilHouse },
        items: [
          {
            name: '公司資料設定',
            to: '/Settings/OfficeData',
            icon: { content: icons.cilImagePlus },
          },  
          {
            name: '訊息參數設定',
            to: '/Settings/Message',
            icon: { content: icons.cilBell },
          },  
          {
            name: '系統參數設定',
            to: '/Settings/SystemParams',
            icon: { content: icons.cilImageBroken },
          }      
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: '用戶密碼權限設定',
        route: '',
        icon: { content: icons.cilInfinity },
        items: [
          {
            name: '營運用戶資料管理',
            to: '/Users/User',
            icon: { content: icons.cilLan },
          },  
          {
            name: '營運角色資料管理',
            to: '/Users/Role',
            icon: { content: icons.cilHighlighter },
          },  
          {
            name: '角色用戶指派',
            to: '/Users/AssignUser',
            icon: { content: icons.cilHandPointRight },
          },  
          {
            name: '用戶角色指派',
            to: '/Users/AssignRole',
            icon: { content: icons.cilHandPointUp },
          },  
          {
            name: '營運用戶密碼修改',
            to: '/Users/PwdChange',
            icon: { content: icons.cilGridSlash },
          },  
          {
            name: '企業用戶資料管理',
            to: '/Users/EnterpriseManager',
            icon: { content: icons.cilGem },
          } 
        ]
      }
        */
    ],
  }
]

</script>
<style scoped>
.c-sidebar .c-sidebar-brand{
  background-color: white;
}
.c-sidebar{
  background-color: #272727;
}

/* 修改「主控版」這類單一項目的選取狀態 */
::v-deep .c-sidebar-nav-link.c-active {
  /* 修改背景顏色 */
  background-color: #3A006F !important; /* 這裡換成你想要的顏色，例如紫色或淺灰色 */
  
  /* 修改文字顏色 */
  color: #ffffff !important;
}

/* 如果有圖標，也要一起改顏色 */
::v-deep .c-sidebar-nav-link.c-active .c-sidebar-nav-icon {
  color: #ffffff !important;
}

/* 展開子項時 */
::v-deep .c-sidebar-nav-dropdown-items {
  background-color: #3C3C3C
}

/* 收起子項時 */
::v-deep .c-sidebar-nav-dropdown-items .c-sidebar-nav-link {
  color: #fbfbfe;
}

/* 鼠標懸停選項時 */
::v-deep .c-sidebar-nav-dropdown-items .c-sidebar-nav-link:hover {
  background-color: #5B00AE;
}

/* 點擊選項後 */
::v-deep .c-sidebar-nav-dropdown-items .c-sidebar-nav-link.c-active {
  color: #ffffff;
  background-color: #3A006F;
}
</style>
